import { ROUTES } from '@/app/routes';
import SenderLegacyRedirect from '@/pages/sender/legacy-redirect';
import { $features } from '@/entities/features-entity';
import { useUnit } from 'effector-react';
import { Navigate } from 'react-router';

/** Legacy bookmark paths (`/sender/campaigns`, …) — hub redirect or sender-app migration. */
export default function SenderLegacyBookmarkRedirect() {
	const { senderWebappEnabled } = useUnit($features);

	if (senderWebappEnabled) {
		return <SenderLegacyRedirect />;
	}

	return <Navigate to={ROUTES.sender} replace />;
}
